export enum Browser {
  Firefox = 'Firefox',
  Chrome = 'Chrome',
  Edge = 'Edge',
  Safari = 'Safari',
  InternetExplorer = 'MSIE',
  Opera = 'Opera',
}
